import { createRouter, createWebHistory } from 'vue-router'

import Home from '../views/Home.vue'
import ItemPage from '../views/item_page.vue'
import Playlist from '../views/playlist.vue'
import Inbox from '../views/inbox.vue'
import inboxIndex from '../views/inboxIndex.vue'
import Dashboard from '../views/dashboard.vue'
import media_dashboard from '../views/media_dashboard.vue'
import pr_dashboard from '../views/pr_dashboard.vue'
import Settings from '../views/Settings.vue'
import SettingsArtist from '../views/SettingsArtist.vue'
import Likes from '../views/likes.vue'
import parade from '../views/parade.vue'
import stats from '../views/stats.vue'
import Linkipedia from '../views/linkipedia.vue'
import Artist from '../views/artist.vue'
import Shows from '../views/shows.vue'
import ShowsAdd from '../views/shows_add.vue'
import MyLinktones from '../views/my_linktones.vue'
import Unpublished from '../views/unpublished.vue'
import Signup from '../views/signup.vue'
import Login from '../views/login.vue'
import VerifyEmail from '../views/verify-email.vue'


const routes = [
  { path: '/', name: 'catalog', component: Home },
  { path: '/Artist/:id', name: 'Artist', component: Artist },
  { path: '/linktone/:id', name: 'item', component: ItemPage },
  { path: '/unpublished/:id', name: 'unpublished', component: Unpublished },
  { path: '/playlist/:id', name: 'playlist', component: Playlist },
  { path: '/inbox', name: 'Inbox', component: Inbox },
  { path: '/inbox/:id', name: 'inbox', component: Inbox},

  { path: '/inboxIndex', name: 'inboxIndex', component: inboxIndex },
  { path: '/dashboard', name: 'dashboard', component: Dashboard, alias: ['/dashboard/:id'] },
  { path: '/media_dashboard', name: 'media_dashboard', component: media_dashboard },
  { path: '/pr_dashboard', name: 'pr_dashboard', component: pr_dashboard },
  { path: '/settings', name: 'Settings', component: Settings },
  { path: '/settings_artist', name: 'SettingsArtist', component: SettingsArtist },
  { path: '/likes', name: 'likes', component: Likes },
  { path: '/parade', name: 'parade', component: parade },
  { path: '/stats', name: 'stats', component: stats },
  { path: '/stats/:id', name: 'statsInner', component: stats },
  { path: '/Linkipedia', name: 'Linkipedia', component: Linkipedia },

  { path: '/edit_shows', name: 'edit_shows', component: Shows },
  { path: '/edit_shows/add', name: 'edit_shows_add', component: ShowsAdd },
  { path: '/my_linktones', name: 'my_linktones', component: MyLinktones },

  { path: '/signup', name: 'signup', component: Signup },
  { path: '/login', name: 'login', component: Login },
  { path: '/verify-email', name: 'verifyEmail', component: VerifyEmail },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  base: process.env.BASE_URL,
  routes,
  
  scrollBehavior(/*to, from, savedPosition*/) {
    return new Promise((resolve/*, reject*/) => {
      setTimeout(() => {
        resolve({ left: 0, top: 0 })
      }, 200)
    })
  },
})

const authPages = ['login', 'signup', 'verifyEmail'];
const publicPages = ['login', 'signup', 'verifyEmail', 'item', 'unpublished'];

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('user_token');

  if (token && authPages.includes(to.name)) {
    next('/');
  } else if (!token && !publicPages.includes(to.name)) {
    next('/login');
  } else {
    next();
  }
})


export default router
